if (!customElements.get('renao-magnet-total')) {
  customElements.define('renao-magnet-total', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info') || this.closest('section');
      this.onQuantity = (event) => {
        if (event.target.matches('.rn-magnet-quantity__input')) this.update();
      };
      this.root?.addEventListener('change', this.onQuantity);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => this.schedule());
      }
      this.schedule();
    }

    disconnectedCallback() {
      this.root?.removeEventListener('change', this.onQuantity);
      this.unsubscribe?.();
      cancelAnimationFrame(this.frame);
    }

    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }

    money(cents) {
      const currency = this.dataset.currency || 'USD';
      const locale = this.dataset.locale || 'en-US';
      return new Intl.NumberFormat(locale, {style: 'currency', currency}).format(cents / 100);
    }

    update() {
      if (!this.isConnected || !this.root) return;
      const input = this.root.querySelector('.rn-magnet-quantity__input');
      const quantity = Math.max(1, Math.floor(Number(input?.value) || 1));
      const unit = Number(this.dataset.unitPrice);
      if (!Number.isFinite(unit) || unit < 0) return;
      const subtotal = unit * quantity;
      const percent = 0;
      const volumeDiscount = Math.round(unit * percent / 100) * quantity;
      const secondItemDiscount = quantity >= 2 ? Math.round(unit * Number(this.dataset.secondItemPercent || 0) / 100) : 0;
      const total = subtotal - Math.max(volumeDiscount, secondItemDiscount);
      this.querySelector('[data-total-price]').textContent = this.money(total);
      const original = this.querySelector('[data-total-original]');
      original.hidden = total === subtotal;
      original.textContent = this.money(subtotal);
      this.querySelector('[data-total-label]').hidden = quantity === 1;
      const unitNote = this.querySelector('[data-total-unit]');
      unitNote.hidden = quantity === 1;
      unitNote.textContent = `${this.money(unit)} each · ${quantity} items`;
      const installment = this.closest('[id^="price-"]')?.querySelector('[data-rn-installment-price]');
      if (installment) installment.textContent = this.money(Math.floor(total / 3));
    }
  });
}
